require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-wojtek-borowicz.json") })
        }
      }, "path---blog-author-wojtek-borowicz");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-wojtek-borowicz!./.cache/json/blog-author-wojtek-borowicz.json
// module id = 712
// module chunks = 231608221292675